import { MatPaginator } from '@angular/material';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { DocumentService } from '@app/api/api';
import { Subject } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Component({
  selector: 'meu-search-by-doc-list',
  templateUrl: './search-by-doc-list.component.html',
  styleUrls: ['./search-by-doc-list.component.scss']
})
export class SearchByDocListComponent implements OnInit {
  @ViewChild('paginator', { static: true }) paginator: MatPaginator;
  constructor(
    private documentService: DocumentService,
    private ref: ChangeDetectorRef,
  ) { }
  filter: any = "";
  pageSize = 10;
  pageIndex = 1;
  total: any;
  lstDocument = [];
  host: any;
  ngOnInit() {
    this.keyUp.pipe(map((event) => event), debounceTime(500)).subscribe((value) => {
      // this.filter = 'name@=*' + value;
      this.paginator.firstPage();
      this.filter = value;
      this.pageIndex = 1;
      this.getAllDocument();
    });
    this.getAllDocument();
  }
  public keyUp = new Subject<KeyboardEvent>();
  getAllDocument() {
    this.documentService.apiDocumentsSearchGet(this.filter, "", "", this.pageIndex, this.pageSize).subscribe(res => {
      if (res.success) {
        this.lstDocument = res.data.collection;
        this.pageSize = res.data.pagesize;
        this.pageIndex = res.data.pageIndex;
        this.total = res.data.total;
        this.host = environment.backendhost;
        this.ref.detectChanges();
      }
    })
  }
  paginatorChange(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.getAllDocument();
  }
}
